import request from './request'


export function getData(url,payload={}){
  return request({
    url,
    method: 'POST',
    data: {...payload}
  })
}